/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';

import {
  LayerGroup, LeafletEvent, Marker,
} from 'leaflet';
import { IModalData } from '@/services/layers/IModalData';

export default class ParkingGroupsLayerService extends LayerService {
  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const hasSpots = !!metaData.last_status
                     && !!metaData.last_status.occupiedSpots
                     && !!metaData.parkingSpots
                     ? 'parking-data--has-data'
                     : 'parking-data--empty-data';

    const template: string = `
    <div class="parking-data">
      <div class="parking-data__description">${metaData.description}</div>
      <div class="${hasSpots}">
        <div class="parking-data__table">
          <table>
            <thead>
              <th>Kategoria miejsc</th>
              <th>Wszystkie miejsca</th>
              <th>Zajęte miejsca</th>
            </thead>
            <tbody>
              <td>${!!metaData.categories ? metaData.categories : this.noData}</td>
              <td>${!!metaData.parkingSpots ? metaData.parkingSpots : this.noData}</td>
              <td>${!!metaData.last_status ? metaData.last_status.occupiedSpots : this.noData}</td>
            </tbody>
          </table>
        </div>
        <div class="empty-data">
          Brak wszystkich informacji o miejscach.
        </div>
      </div>
     </div>
    `;

    const lastUpdate: string = !!metaData.last_status && !!metaData.last_status.dateTime
                       ? metaData.last_status.dateTime as string
                       : this.noData;

    const title: string = `${metaData.name} (${metaData.parkingCode})`

    const modalData: IModalData = {
      title: title,
      content: template,
      navigationPoint: leafletMarker,
      lastUpdate: lastUpdate,
      icon: this.markerIcon,
    };

    store.commit('displayModal', modalData); //-- disable showing modal information
  };

  redrawLayer = (): LayerGroup<any> => {
    const { parkingGroups } = store.state;
    return this.generatePolygonsLayer(parkingGroups);
  };
}
